import { api } from '@/shared/lib/api'
import type {
  Config,
  ExchangeSettingsFormData,
  CategoriesFormData,
  Product,
  ProcessDailyStartedResponse,
  CronLogResponse,
} from '../types'

export const configService = {
  get: async (): Promise<Config> => {
    const { data } = await api.get('/config_for_company/')
    return data
  },

  updateExchangeSettings: async (settings: ExchangeSettingsFormData): Promise<Config> => {
    const { data } = await api.put('/config_for_company/', settings)
    return data
  },

  updateCategories: async (categories: CategoriesFormData): Promise<Config> => {
    const payload = {
      categories: {
        type: 'amount',
        values: {
          oro: categories.oro,
          marmol: categories.marmol,
          bronce: categories.bronce,
        },
      },
    }
    const { data } = await api.put('/config_for_company/', payload)
    return data
  },

  updateEmails: async (emails: Record<string, string>): Promise<Config> => {
    const { data } = await api.put('/config_for_company/', {
      list_notification_emails: emails,
    })
    return data
  },

  updateProducts: async (products: Product[]): Promise<Config> => {
    const { data } = await api.put('/config_for_company/', { products })
    return data
  },

  updateEmailFlags: async (flags: Record<string, boolean>): Promise<Config> => {
    const { data } = await api.put('/config_for_company/', { email_flags: flags })
    return data
  },

  runProcessDaily: async (): Promise<ProcessDailyStartedResponse> => {
    const { data } = await api.post('/benefits/process_daily_admin/')
    return data
  },

  getCronLog: async (id: number): Promise<CronLogResponse> => {
    const { data } = await api.get(`/cron_logs/${id}`)
    return data
  },
}
